import React from "react";
import "./Education.css";
const Education = (props) => {
  return (
    <div className="education" id="education">
      <h4>Education</h4>
      <div className="educontainer">
        <div className="content">
          <div className="school">
            <div className="icon">
              <h3>S</h3>
            </div>
            <h6>SSC-2014</h6>
            <h5>Gouripur R.K. GOVT. High School</h5>
          </div>
        </div>
        <div className="content smargin">
          <div className="school">
            <div className="icon">
              <h3>C</h3>
            </div>
            <h6>HSC-2016</h6>
            <h5>Agricultural University College,Mymensingh</h5>
          </div>
        </div>
        <div className="content smargin">
          <div className="school">
            <div className="icon">
              <h3>U</h3>
            </div>
            <h6>BSc(CSE) 2017-current</h6>
            <h5>University of Rajshahi</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
